import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IButton } from './button.interface';

@Component({
    selector: 'mlp-ng-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ButtonSharedComponent {
    private _btnStyle: string;
    @Input() button: IButton;
    @Input() disabled = false;
    @Input('btnStyle') set btnStyleSetter(value: string) {
        switch (value) {
            case 'lighter': this._btnStyle = 'sg-btn--lighter'; break;
            case 'inverted': this._btnStyle = 'sg-btn--inverted'; break;
            default: this._btnStyle = value;
        }
    }

    @Input() btnSize: string;
    @Input() fullWidth = false;
    get type(): string { return (this.button.type) ? this.button.type : 'button'; }
    get btnStyle(): string { return this._btnStyle; }
}
